import { getCookie, setCookie, getSharedCookieDomain, eraseHostCookie } from "./commonFunction";

const COOKIE_NAME = "dahrToursCurrency";
const COOKIE_HOURS = 24 * 365; // ~1 year
const BASE = "AED";
const SELECTABLE_CODES = ["AED", "USD"];
const CURRENCY_STYLE = {
    AED: { iconClass: "hw-currency", glyph: "AED", position: "before", space: true, decimals: 2 },
    USD: { symbol: "$", position: "before", space: false, decimals: 2 },
    INR: { symbol: "\u20B9", position: "before", space: false, decimals: 0 },
    EGP: { symbol: "E\u00A3", position: "before", space: true, decimals: 2 },
};
const DEFAULT_STYLE = { position: "before", space: true, decimals: 2 };
export const CURRENCY_META = {
    AED: { code: "AED", name: "United Arab Emirates Dirham", ...CURRENCY_STYLE.AED, rate: 1, flag : "https://dahrtours-dev.s3.ap-south-1.amazonaws.com/country-flag-img/uae-flag.jpg" , },
    INR: { code: "INR", name: "Indian Rupees", ...CURRENCY_STYLE.INR, rate: 23.104873 , flag : "https://dahrtours-dev.s3.ap-south-1.amazonaws.com/country-flag-img/in-flag.jpg"},
    USD: { code: "USD", name: "United States Dollar", ...CURRENCY_STYLE.USD, rate: 0.272294 , flag : "https://dahrtours-dev.s3.ap-south-1.amazonaws.com/country-flag-img/us-flag.jpg"},
    EGP: { code: "EGP", name: "Egyptian Pound", ...CURRENCY_STYLE.EGP, rate: 13.803446 , flag : "https://dahrtours-dev.s3.ap-south-1.amazonaws.com/country-flag-img/eg-flag.jpg" },
};

// const getConversionRate = 

let CONVERSION = { AED: { AED: 1 } };
let activeCode = BASE;

let overrideCode = null;

// Frozen booking view: on a booking-detail page we force BOTH the currency
// code AND an explicit AED->currency rate captured at booking time, so amounts
// (which arrive in AED) render exactly as booked, independent of the live
// switcher. { code, rate }. Cleared when leaving the detail view.
let frozenView = null;

let _inited = false;
const ensureInit = () => {
    if (_inited) return;
    _inited = true;
    try {
        const shared = getSharedCookieDomain();
        console.log(shared)
        if (shared) eraseHostCookie(COOKIE_NAME);
        const saved = (getCookie(COOKIE_NAME) || "").trim().toUpperCase();
        if (saved && CURRENCY_META[saved]) activeCode = saved;
    } catch (_) {}
};

export const getCurrencyMeta = (code) => CURRENCY_META[code] || CURRENCY_META[BASE];
export const getActiveCode = () => { ensureInit(); return (frozenView && frozenView.code) || overrideCode || activeCode; };
export const getActiveMeta = () => getCurrencyMeta(getActiveCode());
export const getActiveRate = () => { if (frozenView) return Number(frozenView.rate) || 1; return getActiveMeta().rate || 1; };
export const getBaseCode = () => BASE;
export const getCurrencyOverride = () => (frozenView && frozenView.code) || overrideCode;
export const setBookingView = (code, rate) => { if (!code) { frozenView = null; return null; } frozenView = { code, rate: Number(rate) > 0 ? Number(rate) : 1 }; return frozenView; };
export const clearBookingView = () => { frozenView = null; };
export const getBookingView = () => frozenView;
export const setCurrencyOverride = (code) => {
    // Disabled: checkout no longer forces AED. It now shows the SELECTED
    // (detail-page) currency like the rest of the site, with a tiny
    // "≈ AED x will be charged" note. All amounts are still charged in AED.
    return overrideCode;
};
export const clearCurrencyOverride = () => { overrideCode = null; };
export const getCurrencyList = () =>
    SELECTABLE_CODES.map((c) => CURRENCY_META[c]).filter(Boolean);
export const setActiveCurrency = (code, optionalRate) => {
    if (!CURRENCY_META[code]) code = BASE;
    activeCode = code;
    if (optionalRate != null) {
        CURRENCY_META[code].rate = Number(optionalRate) || CURRENCY_META[code].rate;
    }
    // Write to the shared parent-domain cookie so a switch made in React is
    // also visible to WordPress (and vice-versa). Remove any host-only copy
    // first so it cannot shadow the shared one.
    const shared = getSharedCookieDomain();
    console.log(shared)
    if (shared) eraseHostCookie(COOKIE_NAME);
    setCookie(COOKIE_NAME, code, COOKIE_HOURS, shared || undefined);
    return getActiveMeta();
};
export const hydrateFromUserApi = (names = {}, matrix = {}, selected) => {
    CONVERSION = matrix && matrix[BASE] ? matrix : CONVERSION;
    const aedRow = (matrix && matrix[BASE]) || { [BASE]: 1 };
    Object.keys(names || {}).forEach((code) => {
        const style = CURRENCY_STYLE[code] || DEFAULT_STYLE;
        const rate = code === BASE ? 1 : Number(aedRow[code]);
        CURRENCY_META[code] = {
            ...(CURRENCY_META[code] || {}),
            code,
            name: names[code],
            ...style,
            ...(Number.isFinite(rate) ? { rate } : {}),
        };
    });
    if (!CURRENCY_META[BASE]) {
        CURRENCY_META[BASE] = { code: BASE, name: names[BASE] || "AED", ...CURRENCY_STYLE.AED, rate: 1 };
    }
    CURRENCY_META[BASE].rate = 1;

    const cookieSel = (getCookie(COOKIE_NAME) || "").trim().toUpperCase();
    const next =
        selected && CURRENCY_META[selected]
            ? selected
            : cookieSel && CURRENCY_META[cookieSel]
                ? cookieSel
                : BASE;
    setActiveCurrency(next);
    return getActiveMeta();
};
export const convert = (amount, toCode = activeCode, fromCode = BASE) => {
    const row = CONVERSION[fromCode];
    const rate = row && Number(row[toCode]);
    const factor = Number.isFinite(rate) ? rate : getCurrencyMeta(toCode).rate || 1;
    return Number(amount || 0) * factor;
};
